import api from '@/api'
import * as types from '../mutation-types'

const state = {
  isLoading: false,
  id: null,
  isLoaConditionalRequested: false,
  isLoaRequested: false,
  status_loa: null,
  status_loa_conditional: null,
  loa_data: null,
  cloa_data: null
}

const getters = {
  getLoaData: state => state
}

const actions = {
  requestLoa ({ commit }, data) {
    commit(types.LOA_LOADING)
    api.post('/v2/request_loa', {
      nomor_pendaftar: data.nomor_pendaftar,
      nomor_peserta: data.nomor_peserta,
      tahun: data.tahun,
      kode_jalur: data.kode_jalur,
      kode_prodi: data.kode_prodi,
      jenis_loa: data.jenis_loa,
      status_loa: data.status_loa
    })
      .then(response => {
        commit(types.LOA_REQUEST, response.data)
        commit(types.LOA_LOADING)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
        commit(types.LOA_LOADING)
      })
  },
  getStatusLoaConditional ({ commit }, data) {
    commit(types.LOA_LOADING)
    api.get('/v2/status_loa_conditional/' + data.nomor_peserta)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.LOA_STATUS_CONDITIONAL, response.data)
          commit(types.LOA_LOADING)
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.LOA_LOADING)
        console.log(e)
      })
  },
  getStatusLoa ({ commit }, data) {
    commit(types.LOA_LOADING)
    api.get('/v2/status_loa/' + data.nomor_peserta)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.LOA_STATUS, response.data)
          commit(types.LOA_LOADING)
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.LOA_LOADING)
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.LOA_LOADING] (state) {
    if (!state.isLoading) {
      state.isLoading = true
    } else {
      state.isLoading = false
    }
  },
  [types.LOA_REQUEST] (state, response) {
    state.id = response
    if (state.id.data > state.cloa_data.id) {
      state.status_loa_conditional = '1'
    }
    if (state.id.data > state.loa_data.id) {
      state.status_loa_conditional = '1'
    }
  },
  [types.LOA_STATUS_CONDITIONAL] (state, response) {
    if (response.data !== null) {
      state.isLoaConditionalRequested = true
      state.status_loa_conditional = response.data.status_loa
      state.cloa_data = response.data
    } else {
      state.isLoaConditionalRequested = true
      state.status_loa_conditional = response.data.status_loa
    }
  },
  [types.LOA_STATUS] (state, response) {
    if (response.data !== null) {
      state.isLoaRequested = true
      state.status_loa = response.data.status_loa
      state.loa_data = response.data
    } else {
      state.isLoaRequested = false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loa.js